const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      ...options,
    };

    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    const response = await fetch(url, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Something went wrong');
    }

    return data;
  }

  // Wallet APIs
  async setupWallet(walletData) {
    return this.request('/wallet/setup', {
      method: 'POST',
      body: walletData,
    });
  }

  async getWallet(walletId) {
    return this.request(`/wallet/${walletId}`);
  }

  // Transaction APIs
  async createTransaction(walletId, transactionData) {
    return this.request(`/transactions/transact/${walletId}`, {
      method: 'POST',
      body: transactionData,
    });
  }

  async getTransactions(
    walletId,
    skip = 0,
    limit = 10,
    sortKey = 'date',
    sortDirection = 'DESC'
  ) {
    return this.request(
      `/transactions?walletId=${walletId}&skip=${skip}&limit=${limit}&sortKey=${sortKey}&sortDirection=${sortDirection}`
    );
  }
}

export default new ApiService();
